import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import FleetHeader from './FleetHeader';
import MobileNavigation from '../../components/common/Navigation/MobileNavigation';
import DesktopNavigation from '../../components/common/Navigation/DesktopNavigation';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

class FleetLayout extends Component {
  render() {
    const { location, homeRoute } = this.props;

    return (
      <LayoutContainer>
        <DesktopNavigation location={location} />
        <PageContainer>
          <FleetHeader location={location} homeRoute={homeRoute} />
          <MobileNavigation location={location} />
          {this.props.children}
        </PageContainer>
      </LayoutContainer>
    );
  }
}

FleetLayout.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
  homeRoute: PropTypes.string,
};

const mapStateToProps = state => ({
  homeRoute: state.auth.config.homeRoute,
});

export default connect(mapStateToProps)(FleetLayout);



// WEBPACK FOOTER //
// ./src/layouts/fleet/FleetLayout.js